import styled from 'styled-components';

import colors from '@app/constants/colors';

export const MainContainer = styled.form`
  width: 100%;
  margin-top: 50px;
`;

export const PersonalInfo = styled.section`
  background: linear-gradient(0deg,  ${colors.BEESWAX} 0%, ${colors.ENERGY_YELLOW} 100%);
  padding: 20px 10px;
  color: ${colors.INTERNATIONAL_ORANGE};
`;

export const AccountInfo = styled.section`
  background: linear-gradient(0deg, ${colors.VERY_SOFT_BLUE} 0%, ${colors.SOFT_BLUE} 100%);
  padding: 50px 10px 25px;
`;
